import React from 'react';
import { ReactComponent as ExtruderSVG } from './../images/extruder.svg';

export default function Extruder() {
  return (
    <div className="extruder left">
      <ExtruderSVG />
    </div>
  );
}
